import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu_off",
  "use": "icon-menu_off-usage",
  "viewBox": "0 0 14.749 12.025",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.749 12.025\" id=\"icon-menu_off\">\r\n  <path id=\"icon-menu_off_菜单-收缩\" d=\"M141.718,205.875H127.1v-.982h14.613v.982Zm-7.111-7.325h-7.564v-.982h7.564Zm0,3.607h-7.564v-.982h7.564Zm6.975-7.325H126.969v-.982h14.613v.982Zm-4.369,5.134,4.253-2.835v5.67Z\" transform=\"translate(-126.969 -193.85)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol